import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { ScreenDepth } from "@ryde/theme";

export const LiveMapAutofitLoaderStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "live-map-autofit-loader",
})`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${ScreenDepth.MAP_CONTAINER};
  overflow: hidden;
  pointer-events: none;
  background: rgba(248, 250, 252, 0.38);
  backdrop-filter: blur(2px);
`;
